module.exports = __webpack_public_path__ + "static/media/mail.bc35cff1.svg";